import React, { useEffect } from "react";
import { useStyletron } from "baseui";
import { Grid, Cell } from "baseui/layout-grid";
import { DisplayMedium } from "baseui/typography";

export default function TermsOfService() {
  const [css, theme] = useStyletron();

  useEffect(() => {
    (function (d, s, id) {
      var js,
        tjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs?.parentNode?.insertBefore(js, tjs);
    })(document, "script", "termly-jssdk");

    return () => {
      const tjs = document.getElementById("termly-jssdk");
      tjs?.parentNode?.removeChild(tjs);
    };
  }, []);

  return (
    <>
      <div
        className={css({
          paddingTop: theme.sizing.scale2400,
          paddingBottom: theme.sizing.scale2400,
        })}
      >
        <Grid>
          <Cell span={12}>
            <div
              className={css({
                textAlign: "center",
              })}
            >
              <DisplayMedium $style={{ fontWeight: 300 }}>
                Terms of Service
              </DisplayMedium>
            </div>
          </Cell>
          <Cell span={12}>
            <div
              // @ts-ignore
              name="termly-embed"
              data-id="849424d4-6da0-495b-8384-391378614981"
              data-type="iframe"
            ></div>
          </Cell>
        </Grid>
      </div>
    </>
  );
}
